import { TFLoadingOverlay } from '@tf/ui';
import { useParams } from 'react-router-dom';
import { PaymentsTable } from '@/components/payments';
import { useObjectUriByNodeId } from '@/core/api/legacy';

export const AccountPaymentsTable = () => {
	const { accountId } = useParams<{ accountId: string }>();

	const { data, isPending } = useObjectUriByNodeId(Number(accountId));

	if (isPending) {
		return <TFLoadingOverlay />;
	}

	return <PaymentsTable objectUri={data} />;
};
